/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React, { useContext, useRef } from 'react';
import { CoreContext } from '../../../context/CoreContext';
import { availableVideos } from '../../../services/mock';
import { getScaledValue } from '../../../ui/styled';

import {
  RecommendationContainer,
  RecommendationTitle,
  RecommendationContent,
  RecommendationVideo,
  RecommendationVideoImage,
} from './styled';

interface VideoItem {
  id?: number | string;
  cover?: { uri: string };
  [key: string]: unknown;
}

export default function VideoRecommendations({ relateds }: { relateds: VideoItem[] }) {
  const sliderRef = useRef<HTMLDivElement>(null);
  const { setCurrentVideo } = useContext(CoreContext);

  const CARD_WIDTH = getScaledValue(93);
  const modulesMargin = getScaledValue(12);

  const handleArrowPress = (direction: string, key: number) => {
    const focusSlider = (nextSlide: number) => {
      if (sliderRef.current) {
        const value = (CARD_WIDTH + modulesMargin) * nextSlide;
        sliderRef.current.style.left = `-${value}px`;
      }
    };

    switch (direction) {
      case 'right': {
        const nextSlide = Number(key) + 1;
        if (nextSlide > availableVideos.length - 1) return;
        return focusSlider(nextSlide);
      }
      case 'left': {
        const nextSlide = Number(key) - 1;
        if (nextSlide < 0) return;
        return focusSlider(nextSlide);
      }
      default:
        return;
    }
  };

  return (
    <>
      <RecommendationContainer>
        <RecommendationTitle>Relacionados</RecommendationTitle>
        <RecommendationContent ref={sliderRef}>
          {relateds.map((item: VideoItem, key: number) => (
            <RecommendationVideo
              key={key}
              onArrowPress={(a: string) => handleArrowPress(a, key)}
              onEnterPress={() =>
                setCurrentVideo(item as { id: number | string; [key: string]: unknown })
              }
              onPress={() =>
                setCurrentVideo(item as { id: number | string; [key: string]: unknown })
              }
            >
              <RecommendationVideoImage source={item.cover} />
            </RecommendationVideo>
          ))}
        </RecommendationContent>
      </RecommendationContainer>
    </>
  );
}
